const TABLE = Object.freeze({
  THINGS: 'things',
  TAGS: 'tags'
})

export { TABLE }
